/**
 * @file 发送执行时间统计
 * @author dafo<huanghouin@baijiahulian.com>
 * @module module/timing
*/
import request from './util/request';
import configurable from './util/configurable';
import {
    trackID,
    getUserID,
    Config
} from './util/config';

/**
 * 时间统计上报
 *
 * @function
 * @param {Object} json 要上报的数据
 * @param {Function=} callback 上报后的回调
 */
const report = configurable((json, callback) => {
    // 要上报的数据
    const timingData = {
        // 当前页 URL
        url: location.href,

        // 用户的唯一标识，由后端生成写到 cookie 中
        uuid: trackID,

        // 登录用户 id
        uid: getUserID(),

        ...json
    };

    request(Config.VERB)(`${Config.TIME}`, timingData, callback);
}, {});

const timeMap = {};

/**
 * 开始统计时间
 *
 * @function
 * @param {string} eventID 要开始统计的事件 id，需要在 [罗盘系统](http://newhabo.baijiahulian.com/analysis/#/em) 中创建
 * @return {number} 当前时间（毫秒）
 */
export const time = eventID => (timeMap[eventID] = +new Date());

/**
 * 结束时间统计
 *
 * @function
 * @param {string} eventID 要结束统计的事件 id, 需要在 [罗盘系统](http://newhabo.baijiahulian.com/analysis/#/em) 中创建
 * @return {number} 统计到消耗的时间（毫秒），当传入未经 time 方法调用过的 eventID 时，返回 -1
 */
export const timeEnd = eventID => {
    const start = timeMap[eventID];
    if (!start) {
        return -1;
    }

    const elapsed = +new Date() - start;

    report({eventID, elapsed});

    return elapsed;
};

export default report;
